import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';
import AdminTopBar from '../common/admin/topbar';
import AdminSideNav from '../common/admin/side-nav';

const AdminLayout: React.FC = () => {
  // const [open, setOpen] = useState(true);
  const open = true;
  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      <AdminSideNav open={open} />
      <Box sx={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
        <AdminTopBar
          onToggle={() => {
            // Toogle Side Nav
            // setOpen((o) => !o)
          }}
        />
        <Box
          component="main"
          sx={{
            p: 3,
            overflow: 'auto',
            height: 'calc(100vh - 64px)',
            backgroundColor: 'background.default',
          }}
        >
          <Outlet />
        </Box>
      </Box>
    </Box>
  );
};

export default AdminLayout;
